import { defaultPaginationState } from "utils";

export const initialHealthSafetyState = {
	// pagination
	hazards: defaultPaginationState,
	incidents: defaultPaginationState,
	hazardousSubstances: defaultPaginationState,
	inductions: defaultPaginationState,
	safetyMinutes: defaultPaginationState,
	jobSafetyAnalysis: defaultPaginationState,
	safetyPlanChecklists: defaultPaginationState,
	siteInspectionChecklists: defaultPaginationState,
	staffTrainings: defaultPaginationState,
	staffTrainingTopics: defaultPaginationState,
	
	// Form state
	saving: false,
	savedSuccess: false,
	error: null
};
